import { SET_SELECTED_TAG } from '../../../actions/actionTypes';
import getTagsForLevel from './getTagsForLevel';

/**
 * 選択されたタグIDに基づいて、指定された深さのタグを選択し、次の階層のタグを取得する
 * 階層が5未満の場合には、次の階層のタグを取得するためのAPI呼び出しを行う。
 *
 * @param {string} apiToken - APIトークン
 * @param {number} currentDepth - 現在のタグの階層
 * @param {string} selectedTagId - 選択されたタグのID
 */
const selectTagAndGetNextLevelTags =
  (apiToken, currentDepth, selectedTagId) => dispatch => {
    dispatch({
      type: SET_SELECTED_TAG,
      payload: { depth: currentDepth, id: selectedTagId },
    });

    if (currentDepth < 5) {
      return dispatch(
        getTagsForLevel(apiToken, selectedTagId, currentDepth + 1),
      );
    }

    return undefined;
  };

export default selectTagAndGetNextLevelTags;
